import React from "react";
import { Container, Row, Col } from "reactstrap";
import instagramIcon from "../../assets/icons/instagram.png";
import xIcon from "../../assets/icons/x.png";
import youtubeIcon from "../../assets/icons/Youtube.png";
import githubIcon from "../../assets/icons/github.png";
import linkendinIcon from "../../assets/icons/linkendin.png";

const socialMedia = [
  {
    name: "nCount Instagram",
    icon: instagramIcon,
    url: "https://www.instagram.com/ncount_iofe/",
  },
  {
    name: "nCount Youtube",
    icon: youtubeIcon,
    url: "https://www.youtube.com/@PlaynCount",
  },
  {
    name: "nCount Github",
    icon: githubIcon,
    url: "https://github.com/Forest-Economy-Alliance",
  },
  {
    name: "nCount X",
    icon: xIcon,
    url: "https://x.com/ncountforum",
  },
  {
    name: "nCount Linkendin",
    icon: linkendinIcon,
    url: "https://www.linkedin.com/in/ncount-platform-for-sustainability-action-856679303",
  },
];

function Footer() {
  //   const redirectCommunity = () => {
  //     navigate('/n-fold', { state: { redirectedTabId: '2' } });
  //   };
  return (
    <div className="footer-container">
      <Row>
        <Col md="3" className="footer-links-left">
          <a href="https://ncount.in/privacy-policy" target="_blank" style={{ textDecoration: "none", color: "white" }}>
            {" "}
            <p className="footer-links">Privacy Policies</p>
          </a>
          
          <a href="https://ncount.in/privacy-policy" target="_blank" style={{ textDecoration: "none", color: "white" }}>

          <p className="footer-links">Terms and Conditions</p>
          </a>
        </Col>
        <Col md="6" xs="12" className="footer-icons-container">
          {socialMedia.map((media) => {
            return (
              <a className="footer-icon" href={media.url} target="_blank">
                <img
                  className="footer-icon-img"
                  src={media.icon}
                  alt={media.name}
                />
              </a>
            );
          })}
        </Col>
        <Col md="3" className="footer-links-right">
          <a href="https://ncount.in/contact-us" target="_blank" style={{ textDecoration: "none", color: "white" }}>
            <p className="footer-links">Contact Us</p>
          </a>
          <a
            style={{
              textDecoration: "none",
              color: "white",
              cursor: "pointer",
            }}
          >
            <a href="https://ncount.in/n-fold" target="_blank" style={{ textDecoration: "none", color: "white" }}>
            <p className="footer-links">Community Forum</p>
            </a>
          </a>
        </Col>
      </Row>
    </div>
  );
}

export default Footer;
